import axiosInstance from '../lib/api/axiosInstance';
import { Contact } from '../types';

export interface ContactFormData {
  name: string;
  email: string;
  role?: string;
  phone?: string;
  notes?: string;
  networkId?: number;
  userId?: number;
}

export const contactsApi = {
  // Get all contacts
  getAll: async (): Promise<Contact[]> => {
    const response = await axiosInstance.get<Contact[]>('/contacts');
    return response.data;
  },

  // Get contact by ID
  getById: async (id: number): Promise<Contact> => {
    const response = await axiosInstance.get<Contact>(`/contacts/${id}`);
    return response.data;
  },

  // Create new contact
  create: async (data: ContactFormData): Promise<Contact> => {
    const response = await axiosInstance.post<Contact>('/contacts', data);
    return response.data;
  },

  // Update existing contact
  update: async (id: number, data: Partial<ContactFormData>): Promise<Contact> => {
    const response = await axiosInstance.put<Contact>(`/contacts/${id}`, data);
    return response.data;
  },

  // Delete contact
  delete: async (id: number): Promise<void> => {
    await axiosInstance.delete(`/contacts/${id}`);
  },

  // Get contacts by network
  getByNetwork: async (networkId: number): Promise<Contact[]> => {
    const response = await axiosInstance.get<Contact[]>(`/contacts/network/${networkId}`);
    return response.data;
  }
};